
import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import Select from "react-select";
import Flag from 'react-world-flags'
import { isMobile } from 'react-device-detect'; 

const FormCreate = forwardRef((props, ref) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [isLoadedFilterCountry, setIsLoadedFilterCountry] = useState(false);
    const [selectedOptionDocumentType, setSelectedOptionDocumentType] = useState({ label: "Seleccione tipo de documento", value: "" });
    const [selectedOptionProfession, setSelectedOptionProfession] = useState({ label: "Seleccione la profesión", value: "" });
    const [selectedOptionCountry, setSelectedOptionCountry] = useState({ label: "Seleccione el país", value: "" });
    const [selectedOptionCity, setSelectedOptionCity] = useState({ label: "Seleccione la ciudad", value: "" });
    const [errorValues, setErrorValues] = useState(true);
    const [document_types, setDocumentTypes] = useState([]);
    const [cities, setCities] = useState([]);
    const token = document.querySelector("[name='csrf-token']").content;
    
    const [form, setForm] = useState({ 
        name: "", 
        lastnames: "", 
        phone: "", 
        country_id: props.current_country.id,
        email: "",
        document: null,
        image: {},
        affiliate_user_id: props.affiliate ? props.affiliate.id : "",
        price_id: props.price.id,
        discount_code_id: props.discount.id
    });

    const [message, setMessage] = useState({
        show: false,
        type: "",
        message: []
    });

    const [messageContent, setMessageContent] = useState({ 
        valid: false,
        type: "danger",
        message: "Debes de completar todos los campos requeridos"
    });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value })
    }

    const handleChangeEmail = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value.toLowerCase() })
    }
    
    const handleSubmit = e => {
        e.preventDefault();
    };

    const clearValues = () => {
        setIsLoaded(false);
        setSelectedOptionDocumentType({ label: "Seleccione tipo de documento", value: "" });
        setSelectedOptionProfession({ label: "Seleccione la profesión", value: "" });
        setSelectedOptionCountry({ label: "Seleccione el país", value: "" });
        setSelectedOptionCity({ label: "Seleccione la ciudad", value: "" });

        setForm({ 
            name: "", 
            lastnames: "", 
            phone: "", 
            document: null,
            country_id: props.current_country.id,
            email: "",
            image: {},
            affiliate_user_id: props.affiliate ? props.affiliate.id : "",
            price_id: props.price.id,
            discount_code_id: props.discount.id
        })
    }

    const validationForm = () => {
        if (form.name != "" &&
            form.lastnames != "" &&
            form.phone != "" &&
            form.country_id != "" &&
            form.email != ""
        ) {
            setErrorValues(true)
            return true
        }else{
            setErrorValues(false)
            setMessageContent({
                valid: true,
                type: "danger",
                message: "Debes de completar todos los campos requeridos"
            })
            return false
        }
    }

    const handleClick = () => {
        if (validationForm()) {
            setIsLoaded(true);

            fetch(`/api/v1/users`, {
                method: 'POST', // or 'PUT'
                body: JSON.stringify(form), // data can be `string` or {object}!
                headers: {
                    "X-CSRF-Token": token,
                    "authorization": "98a2425c7cd22d4dad50",
                    "Content-Type": "application/json"
                }
            })

            .then(res => res.json())
            .catch(error => console.error("Error:", error))
            .then(data => {
                console.log(data);
                if(data.type == "success" && data.access_user){
                    props.setUserState(data.register);
                    props.tooglePasstab("payment");
                    clearValues();
                }else{
                    setMessage(data)
                    clearValues();
                }
            });
        }
    }

    const loadDataInput = (country_id) => {
        fetch(`/api/v1/get_country_filter_data/${country_id}`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": token,
                "Content-Type": "application/json",
                "authorization": "98a2425c7cd22d4dad50",
            }
        })
        .then(response => response.json())
        .then(data => {
            setDocumentTypes(data.document_types)
            setCities(data.cities)
            setIsLoadedFilterCountry(false);
        });
    }

    return (
        <React.Fragment>
            <form onSubmit={handleSubmit}>                 
                <div className="card mt-3 user-form">
                    <div className="card-body"> 
                        <div className="row">
                            <div className="col-md-12 text-left mb-3">
                                <div className="title-user-form">
                                    <h4 className='mb-0 text-white'>Información de usuario</h4>
                                </div>
                            </div>
                           
                        
                            <div className={`col-md-6`}>
                                <label className='text-primary'>Nombre <span className='error-label'>*</span></label>
                                <input 
                                    type="text" 
                                    className={`form form-control ${!errorValues && form.name == "" ? "error-class" : ""}`}
                                    name='name'
                                    value={form.name}
                                    onChange={handleChange}
                                    disabled={isLoaded}
                                />
                            </div> 

                            <div className={`col-md-6 ${isMobile ? "mt-2" : ""}`}>
                                <label className='text-primary'>Apellido <span className='error-label'>*</span></label>
                                <input 
                                    type="text" 
                                    className={`form form-control ${!errorValues && form.lastnames == "" ? "error-class" : ""}`}
                                    name='lastnames'
                                    value={form.lastnames}
                                    onChange={handleChange}
                                    disabled={isLoaded}
                                />
                            </div> 

                            <div className="col-md-12">
                                <hr />
                            </div>

                            <div className={`col-md-6`}>
                                <label className='text-primary'>Teléfono / Célular <span className='error-label'>*</span></label>
                                <input 
                                    type="number" 
                                    className={`form form-control ${!errorValues && form.phone == "" ? "error-class" : ""}`}
                                    name='phone'
                                    value={form.phone}
                                    disabled={isLoaded}
                                    onChange={handleChange}
                                />
                            </div> 
                            
                            <div className={`col-md-6 ${isMobile ? "mt-3" : ""}`}>
                                <label className='text-primary'>Correo electrónico <span className='error-label'>*</span></label>
                                <input 
                                    type="text" 
                                    className={`form form-control ${!errorValues && form.email == "" ? "error-class" : ""}`}
                                    name="email" 
                                    value={form.email}
                                    onChange={handleChangeEmail}
                                    disabled={isLoaded}
                                />
                            </div>

                            <div className="col-md-12">
                                <hr />
                            </div>

                            <div className="col-md-6">
                                <label className='text-primary'>Número del documento</label>
                                <input 
                                    type="text" 
                                    className={`form form-control`}
                                    name='document'
                                    value={form.document}
                                    onChange={handleChange}
                                    disabled={isLoaded}
                                />
                                <span>({props.label_document})</span>
                            </div> 

                            <div className={`col-md-6 ${isMobile ? "mt-3" : ""}`}>
                                <label className='text-primary'>Pais</label> <br />
                                <Flag code={props.current_country.code} height="40" />
                            </div> 
 
                        </div>
                    </div>

                    {message.show && (
                        <div className="col-md-12 mt-4">
                            <div className={`alert alert-${message.type} text-center`} role="alert">
                                <ul>
                                    {message.success.map((error, index) => (
                                        <React.Fragment>
                                            <li key={index}><b>{error}</b></li>
                                        </React.Fragment>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    )}

                    {messageContent.valid && (
                        <div className="col-md-12 mt-4">
                            <div className={`alert alert-${messageContent.type} text-center text-white`} role="alert">
                                <b>{messageContent.message}</b>
                            </div>
                        </div>
                    )}

                    {true && (
                        <div className={`card-footer ${isMobile ? "text-center" : "" }`}>
                            <button className={`btn btn-primary ${isMobile ? "btn-block" : ""}`} disabled={isLoaded} onClick={() => handleClick()}>{isLoaded ? "Cargando..." : "Siguiente"}</button>
                            <a href="javascript:void(0)" className='ml-2 text-primary' onClick={() => props.toogleTab("user_login")}>¿Ya eres un usuario en nuestra plataforma?</a>
                        </div>
                    )}
                </div>     
            </form>
        </React.Fragment>
    );
});


export default FormCreate;
